/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierDocumentType {
  RulesAndCharges = "rules_and_charges",
  Rates = "rates",
  ServiceAndCoverage = "service_and_coverage",
  Contacts = "contacts",
  BankingAndCredit = "banking_and_credit",
  ComplianceAndInsurance = "compliance_and_insurance",
  Agreements = "agreements",
  Technical = "technical",
  Notices = "notices",
  Other = "other",
}

export function instanceOfCarrierDocumentType(value: any): boolean {
  for (const key in CarrierDocumentType) {
    if (Object.prototype.hasOwnProperty.call(CarrierDocumentType, key)) {
      if (
        CarrierDocumentType[key as keyof typeof CarrierDocumentType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierDocumentTypeFromJSON(json: any): CarrierDocumentType {
  return CarrierDocumentTypeFromJSONTyped(json, false);
}

export function CarrierDocumentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierDocumentType {
  return json as CarrierDocumentType;
}

export function CarrierDocumentTypeToJSON(
  value?: CarrierDocumentType | null,
): any {
  return value as any;
}

export function CarrierDocumentTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierDocumentType {
  return value as CarrierDocumentType;
}
